import compact from "lodash/compact";
import React from "react";

export interface FakeButtonProps extends Omit<React.HTMLProps<HTMLButtonElement>, "type"> {
	icon?: string;
}

export const FakeButton = React.forwardRef<HTMLButtonElement, FakeButtonProps>(
	({ className, icon, children, ...props }, ref) => {
		const iconOnly = !children && !!icon;
		const classes = compact([
			"btn-reset",
			className,
			!children && !!icon && "btn-icon-only",
			iconOnly && "px-3",
		]).join(" ");

		return (
			<button type="button" ref={ref} className={classes} {...props}>
				{icon && <i className={`btn-fa-icon ${icon}${iconOnly ? "" : " mr-2"}`} aria-hidden="true" />}
				{children}
			</button>
		);
	},
);
